/**
 * Where focus goes in a workspace view when the element holding it leaves:
 * the view's roving tab stop (its one item with tabindex 0), the item that
 * took the place of the one that left.
 */

/** The views' item containers: the canvas grids and the sidebar tree. */
export const VIEW_CONTAINER = '[role="grid"], [role="tree"]';

/** A view's roving tab stop: its one item with tabindex 0. */
const TAB_STOP = ['row', 'gridcell', 'treeitem']
  .map((r) => `[role="${r}"][tabindex="0"]`)
  .join(', ');

/** The tab stop of the view `container` is (or holds), or null. */
export function viewTabStop(container: Element | null): HTMLElement | null {
  if (!container?.isConnected) return null;
  const view = container.matches(VIEW_CONTAINER)
    ? container
    : container.querySelector(VIEW_CONTAINER);
  return view?.querySelector<HTMLElement>(TAB_STOP) ?? null;
}
